/**
 * Earth Animal — Pet Toggle (Dog/Cat)
 * Handles click events, persists selection via cookie,
 * and dispatches a custom event for other scripts to react to.
 */

function eaPetToggle(pet, e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }

  var COOKIE_DAYS = 365;
  var expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
  document.cookie = 'ea_pet=' + pet + '; expires=' + expires + '; path=/; SameSite=Lax';

  var pills = document.querySelectorAll('.ea-pet-toggle__pill');
  pills.forEach(function (pill) {
    pill.classList.toggle('ea-pet-toggle__pill--active', pill.dataset.pet === pet);
  });

  // Swap nav menus
  document.querySelectorAll('[data-pet-menu]').forEach(function (el) {
    el.style.display = el.dataset.petMenu === pet ? '' : 'none';
  });

  // Recalc mega menu dropdown positions for newly visible items
  setTimeout(function () {
    document.querySelectorAll('[data-pet-menu="' + pet + '"] .site-nav__dropdown.mega-menu-dropdown').forEach(function (dropdown) {
      var li = dropdown.closest('li.site-nav--has-dropdown');
      if (li) {
        var rect = li.getBoundingClientRect();
        var offset = -rect.left;
        dropdown.style.left = offset + 'px';
      }
    });
  }, 50);
}

// Init — set state from cookie on load
(function () {
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function init() {
    var savedPet = getCookie('ea_pet') || 'dog';

    // Set desktop toggle state
    var pills = document.querySelectorAll('.ea-pet-toggle__pill');
    pills.forEach(function (pill) {
      pill.classList.toggle('ea-pet-toggle__pill--active', pill.dataset.pet === savedPet);
    });

    // Inject toggle into mobile drawer
    var mobileUl = document.querySelector('ul.mobile-nav--main');
    if (mobileUl && !mobileUl.querySelector('.ea-pet-toggle--mobile')) {
      var li = document.createElement('li');
      li.className = 'ea-pet-toggle ea-pet-toggle--mobile';
      li.innerHTML =
        '<button class="ea-pet-toggle__pill" data-pet="dog" onclick="eaPetToggle(\'dog\', event)">Dog</button>' +
        '<button class="ea-pet-toggle__pill" data-pet="cat" onclick="eaPetToggle(\'cat\', event)">Cat</button>';
      mobileUl.insertBefore(li, mobileUl.firstChild);

      li.querySelectorAll('.ea-pet-toggle__pill').forEach(function (pill) {
        pill.classList.toggle('ea-pet-toggle__pill--active', pill.dataset.pet === savedPet);
      });
    }

    window.eaPet = {
      get: function () { return getCookie('ea_pet') || 'dog'; }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();